import { render, staticRenderFns } from "./region-select.vue?vue&type=template&id=1aae2c72&scoped=true&"
import script from "./region-select.vue?vue&type=script&lang=ts&"
export * from "./region-select.vue?vue&type=script&lang=ts&"
import style0 from "./region-select.vue?vue&type=style&index=0&id=1aae2c72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aae2c72",
  null
  
)

component.options.__file = "region-select.vue"
export default component.exports